import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSesion } from '../contexto/Sesion.js';
import { Constancias } from './Constancias.js';
import { BajasPortal } from './BajasPortal.js';
import { Empleados } from './Empleados.js';
import { FacturacionPortal } from './FacturacionPortal.js';
import { FacturasPortal } from './Facturas.js';
import { PerfilEmpresa } from './PerfilEmpresa.js';
import { ProveedorToast } from '../componentes/Toast.js';

export function PortalApp() {
  const { portal, salir } = useSesion();
  const navegar = useNavigate();
  const [seccion, setSeccion] = useState<'auditorias' | 'ausencias' | 'empleados' | 'facturacion' | 'perfil'>('auditorias');

  if (!portal) return null;

  return (
    <ProveedorToast>
      <div className="cabecera-web">
        <div className="cabecera-web-interior">
          <div className="cabecera-logo">🩺 {portal.operador} · {portal.empresa}</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span className="pill-rol">{portal.rol === 'SERVICIO_MEDICO' ? 'Servicio Médico' : 'RRHH'}</span>
            <span className="muted">{portal.nombre}</span>
            <button className="fantasma" onClick={() => { salir(); navegar('/'); }}>Salir</button>
          </div>
        </div>
      </div>
      <div className="web" style={{ animation: 'fadeInUp 0.4s ease forwards' }}>
        {/* Menú de pestañas */}
        <nav className="nav-portal" aria-label="Secciones del portal">
          <button 
            className={`nav-tab ${seccion === 'auditorias' ? 'activo' : ''}`}
            onClick={() => setSeccion('auditorias')}
          >
            📋 Constancias y Auditorías
          </button>
          <button 
            className={`nav-tab ${seccion === 'ausencias' ? 'activo' : ''}`}
            onClick={() => setSeccion('ausencias')}
          >
            🩹 Gestión de Ausencias
          </button>
          <button 
            className={`nav-tab ${seccion === 'empleados' ? 'activo' : ''}`}
            onClick={() => setSeccion('empleados')}
          >
            👥 Nómina de Empleados
          </button>
          <button
            className={`nav-tab ${seccion === 'facturacion' ? 'activo' : ''}`}
            onClick={() => setSeccion('facturacion')}
          >
            💰 Liquidación y Pagos
          </button>
          <button
            className={`nav-tab ${seccion === 'perfil' ? 'activo' : ''}`}
            onClick={() => setSeccion('perfil')}
          >
            🏢 Perfil de la Empresa
          </button>
        </nav>

        {seccion === 'auditorias' && <Constancias />}
        {seccion === 'ausencias' && <BajasPortal />}
        {seccion === 'empleados' && <Empleados />}
        {seccion === 'facturacion' && (
          <>
            <FacturacionPortal />
            <FacturasPortal />
          </>
        )}
        {seccion === 'perfil' && <PerfilEmpresa />}
      </div>
    </ProveedorToast>
  );
}
